Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.ChartExportModal extends Backbone.View
  template: JST["backbone/templates/monitoring/chart_export_modal"]
  headerTemplate: JST["backbone/templates/monitoring/chart_header_template"]
  pageTemplate: JST["backbone/templates/monitoring/chart_page_style_template"]
  headerReportTemplate: JST["backbone/templates/monitoring/chart_page_header_style_template"]

  events:
    'click #export-charts': '_onExportCharts'
    'click #cancel-export': '_onCancelExport'

  initialize: (@options = {}) ->
    @charts = @options.charts
    @isPreviewMode = @options.isPreview
    @dashboard_view = @options.dashboard_view
    @searchQuery = @options.searchQuery
    @title = @searchQuery.get('chart_report_title') || 'Insert a report name'
    @possible_applied_filters = [
      {name: 'Keywords Included' , query_name: 'texts', has_logic: true, logic: 'texts_logic' },
      {name: 'Keywords Excluded', query_name: 'text_exclusions', has_logic: true, logic: 'texts_logic'}
      {name: 'Intelligent Tags' , query_name: 'tags', has_logic: false },
      {name: 'Excluded Tags' , query_name: 'excluded_tags', has_logic: false },
      {name: 'Sentiment' , query_name: 'sentiment', has_logic: false },
      {name: 'Group' , query_name: 'labels', has_logic: false },
      {name: 'Own Content - Include Own Content', query_name: 'include_page_owner_generated', has_logic: false },
      {name: 'Own Content - Exclude Own Content', query_name: 'exclude_page_owner_generated', has_logic: false},
      {name: 'Gender' , query_name: 'enhanced_gender', has_logic: false },
      {name: 'Source' , query_name: 'type', has_logic: false },
      {name: 'Source Type' , query_name: 'sub_type', has_logic: false },
      {name: 'Users' , query_name: 'users', has_logic: false},
      {name: 'Include Influencers List', query_name: 'influencer_list', has_logic: false },
      {name: 'Include Klout Score', query_name: 'klout_score', has_logic: false },
      {name: 'Countries' , query_name: 'countries', has_logic: false },
      {name: 'Review Status' , query_name: 'review_status', has_logic: false },
      {name: 'Moderator' , query_name: 'moderators', has_logic: false },
      {name: 'Moderation Result' , query_name: 'status', has_logic: false },
      {name: 'Last Moderation Time' , realtime: 'moderation_date_from_realtime', from: 'moderation_date_from_ISO', to: 'moderation_date_to_ISO' },
      {name: 'Lenguage' , query_name: 'languages', has_logic: false }
    ]

  render: ->
    @$el.html(@template({date_filter: @getDateFilter('date_from_realtime', 'date_from_ISO', 'date_to_ISO' ), topics: @getTopics(), appliedFilters: @getAppliedFilters(), title: @title}))
    return this

  getTopics: ->
    topics = []
    if @searchQuery.get('topics')?
      topics.push @searchQuery.get('topics')[key].name for key of @searchQuery.get('topics')
    else
      topics.push I18n.t('monitoring.dashboard.all_topics')
    topics.join(', ')

  getDateFilter: (realtime, from, to) ->
    if @searchQuery.get(realtime)?
      today = new Date().toString()
      @searchQuery.get(realtime).name+"("+today+")"
    else if @searchQuery.get(from)?
      if @searchQuery.get(to)?
        "FROM: #{@searchQuery.get(from).slice(0, -5).replace('T', ' ')} -- TO: #{@searchQuery.get(to).slice(0, -5).replace('T', ' ')}"
      else
        "FROM: #{@searchQuery.get(from).slice(0, -5).replace('T', ' ')} -- TO: #{new Date().toISOString().slice(0, -5).replace('T', ' ')}"
    else
      "From the begining of time"

  getAppliedFilters: ->
    applied_tags_list = []
    for possible in @possible_applied_filters
      unless possible.name == 'Last Moderation Time'
        data = @searchQuery.get(possible.query_name)
        if data?
          if data instanceof Array && data.length > 0
            if possible.has_logic
              applied_tags_list.push "&#9679 #{possible.name}: #{data.join("  #{@searchQuery.get(possible.logic)}  ")}  &#10 "
            else
              applied_tags_list.push "&#9679 #{possible.name}: #{data.join(', ')}  &#10 "
          else
            applied_tags_list.push "&#9679 #{possible.name}: #{data}  &#10 " if data && (typeof(data) == 'boolean' || data.length > 0)
      else
        mod_time = @getDateFilter(possible.realtime, possible.from, possible.to)
        applied_tags_list.push "&#9679 Last Moderation Time: #{mod_time}  &#10 " unless mod_time == 'From the begining of time'
    if applied_tags_list.length > 0
      return applied_tags_list.join(' ')
    else
      return 'No filters applied'

  getUserText: ->
    user_section_title = $('#user-section-title').val()
    user_section_text = $('#user-section-text').val()
    @pageTemplate({user_section_text: user_section_text, user_section_title: user_section_title})

  _updateTitleIfChanged: (title) =>
    if title != @searchQuery.get('chart_report_title')
      @searchQuery.changeState('chart_report_title', title)

  _onExportCharts: ->
    title = @$el.find("#title-edition").val()
    @_updateTitleIfChanged(title)
    date_interval = if @$el.find('#show-date-filter #visibility-checkbox input').is(':checked') then @getDateFilter('date_from_realtime', 'date_from_ISO', 'date_to_ISO') else null
    topics = if @$el.find('#show-selected-topics #visibility-checkbox input').is(':checked') then @getTopics() else null
    filters = if @$el.find('#show-active-filters #visibility-checkbox input').is(':checked') then @getAppliedFilters() else null
    custom_text = if @$el.find('#editable-user-text #visibility-checkbox input').is(':checked') then @getUserText() else '<div></div>'
    header = @_generateHeader(title,date_interval,topics,filters)
    @dashboard_view.add_dom_to_front($(header), '#table')
    page = @_generatePage(title,date_interval,1)
    @dashboard_view.add_dom_to_front($(page), '#page-header')
    @_export_charts(header, page, custom_text)



  _onCancelExport: ->
    title = @$el.find("#title-edition").val()
    @_updateTitleIfChanged(title)

  _generateHeader:(title, date_interval, selected_topics, applied_filters)->
    @headerTemplate({title: title, date_interval: date_interval, topics: selected_topics, filters: applied_filters})

  _generatePage: (title, date_interval, page_number)->
    @headerReportTemplate({title: title, date_interval: date_interval, page_number: page_number})    

  _export_charts:(header,page, custom_text) ->
    @$el.find('#export-charts').addClass('disabled')
    data = { sections: [], format: 'pdf', type: 'graph' }
    data.sections.push(header)
    data.sections.push(page)
    data.sections.push(custom_text)
    @$el.find('.image').on('load', this.run)
    if !@isPreviewMode
      $.post('/monitoring/reports/exporter/export', data, (response) =>
        @jobId = response.job_id
        swal("Export started!", "We will send you an email once it's completed", "success")
        @$el.find('#export-charts').removeClass('disabled')
        @$el.find('#chart_export_modal').modal('hide')
        @_askIfCompleted()
      )
    else
      setTimeout(@print_if_ready(), 2000) 
    
  print_if_ready:() =>
    @$el.find('#chart_export_modal').modal('hide')
    window.print()

  run: () ->
    @image_loaded = true

  _askIfLoaded: =>
    @image_loaded || false

  _askIfCompleted: =>
    data = { job_id: @jobId }
    $.get('/monitoring/reports/exporter/export_finish', data, (response) =>
      if response.status == 'completed'
        @$el.find('#export-charts').removeClass('disabled')
        @$el.find('#chart_export_modal').modal('hide')
        @_downloadPdf(response.link)
        @downloadPdf()

      else if response.status == 'failed'
        showError('Exportation failed. If this error error persists, please contact us.')
        @$el.find('#export-charts').removeClass('disabled')
      else if response.status != 'not_found'
        setTimeout(@_askIfCompleted, 2000)
    )
  downloadPdf: ->
    $.get('/monitoring/reports/exporter/download_exported?job_id='+this.jobId)

  _downloadPdf: (link) ->
    anchor = $( "<a></a>" )
    anchor[0].href = link
    anchor[0].download = ''
    anchor[0].click()
